import React, { useContext, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Typography,
  Box,
} from '@mui/material';
import { motion } from 'framer-motion';
import { AuthContext } from '../AuthContext';
import { showSwalNotification } from '../../utils/SwalResponse';

const reasons = [
    "The account has been deactivated due to multiple user reports indicating spam behavior.",
    "The account was found to be in violation of the platform's terms of service.",
    "The account has been inactive for an extended period, leading to automatic deactivation.",
    "Evidence of fraudulent behavior or attempts to deceive other users.",
    "Reports of harassment or abusive behavior towards other users.",
    "The account was found to be impersonating another user or entity.",
    "Posting or sharing content that violates community guidelines.",
    "The account was accessed without authorization, leading to security concerns.",
    "Repeated posting of unsolicited promotional content or spam links.",
    "Having multiple accounts that violate platform policies.",
    "The account owner requested deactivation for personal reasons.",
    "Other",
];

const MotionBox = motion(Box);

const AccountDeactivation = ({ user, open, onClose, setLoading, setFoundUser }) => {
  const { updateUserStatus } = useContext(AuthContext)
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setLoading(true);
    const reason =
      selectedReason === 'Other' ? customReason.trim() : selectedReason;

    if (!reason) {
      setError('Please provide a reason for deactivation.');
      return;
    }

    // Handle deactivation logic here
    

    const response = await updateUserStatus({reason, user_id: user.id, status: 'inactive'});
    showSwalNotification(response)
    if (response?.status === 'success') {
      setFoundUser(response?.data);
      setLoading(false);
    // Reset and close
        setSelectedReason('');
        setCustomReason('');
        onClose();
    }

    
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <MotionBox
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <DialogTitle>Deactivate Account</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Please let us know why you're deactivating This account.
          </Typography>

          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel id="reason-label">Reason</InputLabel>
            <Select
              labelId="reason-label"
              value={selectedReason}
              label="Reason"
              onChange={(e) => {
                setSelectedReason(e.target.value);
                setError('');
              }}
            >
              {reasons.map((reason) => (
                <MenuItem key={reason} value={reason}>
                  {reason}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {selectedReason === 'Other' && (
            <TextField
              label="Please specify"
              multiline
              rows={3}
              fullWidth
              value={customReason}
              onChange={(e) => {
                setCustomReason(e.target.value);
                setError('');
              }}
              sx={{ mb: 2 }}
            />
          )}

          {error && (
            <Typography color="error" sx={{ mb: 1 }}>
              {error}
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} color="secondary">
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleSubmit}>
            Deactivate
          </Button>
        </DialogActions>
      </MotionBox>
    </Dialog>
  );
};

export default AccountDeactivation;
